import React from 'react';
import SeoArticlePage from './SeoArticlePage';

export default function PostMatchAnalysisPage() {
  return (
    <SeoArticlePage
      title="IPL Post Match Analysis | IPL Match Analysis and Trading Review"
      description="IPL post match analysis to review prediction quality, role accuracy and portfolio decisions. Improve your next trade cycle with structured match analysis."
      canonicalPath="/post-match-analysis"
      keywords="post match analysis, ipl match analysis, ipl analytics, fantasy cricket prediction, ipl player performance analysis"
      heading="Post Match Analysis"
      intro="A strong post-match process turns random outcomes into learning. Evaluate where the model was right, where context shifted and how your trades reacted."
      sections={[
        {
          title: 'Review Template',
          body: 'Run this after every game to improve consistency.',
          bullets: ['Prediction vs outcome variance', 'Role changes not captured pre-match', 'Entry timing and exit timing quality'],
        },
        {
          title: 'Price Behavior Notes',
          body: 'Record whether price moved on fundamentals or short-term sentiment. This improves future confidence scoring.',
        },
        {
          title: 'Next Match Carry-Forward',
          body: 'Promote lessons into your next checklist so analysis compounds over the season.',
        },
      ]}
    />
  );
}
